/* eslint-disable react/prop-types, consistent-return */
import React, { useEffect, useState, useRef } from 'react'

import { Wrapper } from './FadeInWrapper.style'

export function useInViewObserver({ threshold = 0.5, ...options }) {
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!ref.current || typeof window === 'undefined') return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold, ...options }
    )

    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ref])

  return { ref, isVisible }
}



function FadeInWrapper({ children, delay = 0, visibilityPercentage = 0.35, simple = false, ...otherProps }) {
  const { ref, isVisible } = useInViewObserver({ threshold: visibilityPercentage })

  return (
    <Wrapper {...otherProps} ref={ref} delay={delay} isVisible={isVisible} simple={simple}>
      {children}
    </Wrapper>
  )
}

export default FadeInWrapper